import { IPwaClientApiRow, IPwaClientSyncResult, PwaClient } from '../types';

export function parsePwaClientResponse(payload: unknown): IPwaClientSyncResult {
    if (!Array.isArray(payload) || payload.length === 0) {
        return { status: 'error', note: 'EmptyResponse' };
    }

    const row = payload[0] as IPwaClientApiRow;
    const note = typeof row.Note === 'string' ? row.Note : undefined;

    if (note !== 'Success') {
        return { status: 'error', note: note || 'Unknown' };
    }

    return {
        status: 'synced',
        client: toClient(row.Client),
        tracked: Number(row.Tracked) === 1,
        note,
    };
}

function toClient(value: unknown): PwaClient | undefined {
    return value === 'web' || value === 'pwa' ? value : undefined;
}
